import { render, staticRenderFns } from "./Empresas-y-corporativos.vue?vue&type=template&id=6055ba42&scoped=true&"
import script from "./Empresas-y-corporativos.vue?vue&type=script&lang=js&"
export * from "./Empresas-y-corporativos.vue?vue&type=script&lang=js&"
import style0 from "./Empresas-y-corporativos.vue?vue&type=style&index=0&id=6055ba42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055ba42",
  null
  
)

export default component.exports